import { useRef } from 'react';
import { toast } from 'react-toastify';
import '../../styles/Buttons.css';

const MediaTile = ({
  media,
  onDelete,
  selectable = false,
  onSelect }) => {
  const prefetchedRef = useRef(false);

  // 🔑 Preview source (fast thumbnail for video)
  const previewSrc =
    media.type === 'video'
      ? media.thumbnailUrl
      : media.url;

  // 🔑 Full asset for prefetch
  const fullSrc = media.url;

  const prefetchFullAsset = () => {
    if (prefetchedRef.current) return;
    prefetchedRef.current = true;

    if (!fullSrc) return;

    if (media.type === 'image') {
      const img = new Image();
      img.src = fullSrc;
    }

    if (media.type === 'video') {
      const video = document.createElement('video');
      video.src = fullSrc;
      video.preload = 'metadata';
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (!onDelete) return;

    toast.warning(
      <div>
        <div style={{ marginBottom: 8 }}>Delete this media?</div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            className="btn-danger"
            onClick={() => {
              toast.dismiss();
              onDelete(media);
            }}
          >
            Delete
          </button>
          <button
            className="btn-secondary"
            onClick={() => toast.dismiss()}
          >
            Cancel
          </button>
        </div>
      </div>,
      { autoClose: false }
    );
  };

  return (
    <div
      className="media-library-tile"
      style={{
        cursor: 'pointer',
        contentVisibility: 'auto',
        containIntrinsicSize: '120px 120px',
      }}
      onMouseEnter={prefetchFullAsset}   // 🚀 HOVER PREFETCH
      onTouchStart={prefetchFullAsset}   // 📱 mobile support
    >
      <div className={`media-library-tile-preview ${media.type === 'video' ? 'video' : ''}`}>
        <img
          src={previewSrc}
          alt=""
          loading="lazy"
          decoding="async"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            background: '#111',
            borderRadius: '6px'
          }}
        />
      </div>

      <div className="media-tile-footer">

        {selectable ? (

          <button
            className="btn-green"
            onClick={() => onSelect?.(media)}
          >
            Select
          </button>

        ) : (

          <button
            className="media-delete-btn"
            onClick={() => onDelete(media)}
          >
            Delete
          </button>

        )}

      </div>
    </div>
  );
};

export default MediaTile;
